const LogoAlternatif = {

    lastUrl: '',
    init() {
        this.check()

        setInterval(() => {
            this.check()
        }, 500)
    },

    rtrim(str, charToRemove) {
        if (charToRemove === undefined) {
            charToRemove = '\\s'; // Par défaut, supprime les espaces
        } else {
            charToRemove = charToRemove.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Échappe les caractères spéciaux
        }
        const regex = new RegExp(charToRemove + '+$');
        return str.replace(regex, '');
    },

    check() {
        if (this.lastUrl === window.location.href) {
            return
        }
        this.lastUrl = window.location.href
        const currentUrl = this.rtrim(window.location.href.replace(window.location.origin, ''), '/')
        const logoAlternatifWrappers = document.querySelectorAll('.logo-alternatif-wrapper')

        let hasLogoAlternatif = false

        logoAlternatifWrappers.forEach(wrapper => {
            if (wrapper.dataset.pageUrl === currentUrl) {
                wrapper.classList.add('logo-wrapper-visible')
                hasLogoAlternatif = true
            } else {
                wrapper.classList.remove('logo-wrapper-visible')
            }
        })

        if (!hasLogoAlternatif) {
            const visibleLogoALternatif = document.querySelectorAll('.logo-alternatif-wrapper.logo-wrapper-visible')
            if (visibleLogoALternatif) {
                visibleLogoALternatif.forEach(
                    logo => logo.classList.remove('logo-wrapper-visible')
                )
            }
            document.querySelectorAll('.logo-normal').forEach(
                logo => logo.classList.add('logo-wrapper-visible')
            )
        } else {
            document.querySelectorAll('.logo-normal').forEach(
                logo => logo.classList.remove('logo-wrapper-visible')
            )
        }
    }
}

export default LogoAlternatif
